import React from 'react';
import { Container, Typography, Box, Grid2 as Grid } from '@mui/material';
import Footer from "../layout/Footer";

const PoliticaPrivacidad = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container size={12} sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              OneService - Política de Privacidad
            </Typography>
            <Typography variant="h3" component="h3" gutterBottom sx={{ color: 'white', textAlign: 'center' }}>
              Fecha de última actualización: {new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
            </Typography>
          </Grid>
        </Container>
      </Box >

      <Container maxWidth="md" sx={{ py: 6 }}>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            1. Responsable del tratamiento
          </Typography>
          <Typography variant="body1" paragraph>
            OneService es responsable del tratamiento de datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            2. Datos recopilados
          </Typography>
          <Typography variant="body1" paragraph>
            Podrán recabarse:<br />
            · Datos de identificación.<br />
            · Datos de contacto.<br />
            · Información de ubicación.<br />
            · Información de pago (procesada por terceros).<br />
            · Datos técnicos de navegación.
          </Typography>
          <Typography variant="body1" paragraph>
            No se recaban datos sensibles salvo que resulte estrictamente necesario.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            3. Finalidades
          </Typography>
          <Typography variant="body1" paragraph>
            Los datos serán utilizados para:<br />
            · Conectar Clientes y Proveedores.<br />
            · Procesar pagos.<br />
            · Atender solicitudes.<br />
            · Cumplir obligaciones legales.<br />
            · Mejorar la Plataforma.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            4. Derechos ARCO
          </Typography>
          <Typography variant="body1" paragraph>
            El titular podrá ejercer sus derechos de:<br />
            · Acceso<br />
            · Rectificación<br />
            · Cancelación<br />
            · Oposición
          </Typography>
          <Typography variant="body1" paragraph>
            Mediante solicitud enviada al correo de contacto oficial de OneService.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            5. Transferencias
          </Typography>
          <Typography variant="body1" paragraph>
            Los datos podrán compartirse con:<br />
            · Procesadores de pago.<br />
            · Proveedores tecnológicos.<br />
            · Autoridades competentes.
          </Typography>
          <Typography variant="body1" paragraph>
            No se comercializan datos personales.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            6. Medidas de Seguridad
          </Typography>
          <Typography variant="body1" paragraph>
            Se implementan medidas técnicas, administrativas y físicas razonables para proteger la información.
          </Typography>
        </Box>

      </Container>
      <Footer />
    </>
  );
};

export default PoliticaPrivacidad;
